import { render } from "./AbsenceComponent.vue?vue&type=template&id=7e640514"
import script from "./AbsenceComponent.vue?vue&type=script&lang=js"
export * from "./AbsenceComponent.vue?vue&type=script&lang=js"

import "./AbsenceComponent.vue?vue&type=style&index=0&id=7e640514&lang=scss"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__